import React from 'react'

const Projects = () => {
  return (

    <div className="container-fluid feature bg-light py-5">
        <div className="container py-5">
            <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                <h4 className="text-uppercase text-primary">Our Feature</h4>
                <h1 className="display-3 text-capitalize mb-3">Projects Delivered with Our Partners</h1>
            </div>
            <div className="row g-4">
                <div className=" col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="feature-item">
                             <img src="img/yai-logo.png" width="100%" />
                        <a href="#" className="h4 mb-3">YAI & The Grassroot Innovation Scouting</a>
                        <p className="mb-3">A project initiated to unearth & groom Grassroot Solutioneers with innovations from atypical Communities in Ghana.</p>
                        <a href="#" className="btn text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="feature-item">
                        <img src="img/giz.jpg" style={{height:'200px'}} width="100%" />
                        {/* <!-- <div className="feature-icon mb-3"><i className="fas fa-filter text-white fa-3x"></i></div> --> */}
                        <br />
                        <a href="#" className="h4 mb-3">E-Skills 4 Girls</a>
                        <p className="mb-3">With the help of GIZ, we trained kente women in Ntonso on how to market their products using WhatsApp & other Social Media Channels.</p>
                        <br />
                        <a href="#" className="btn text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="feature-item">
                        <img src="img/screening.jpg" width="100%" />
                        {/* <!-- <div className="feature-icon mb-3"><i className="fas fa-recycle text-white fa-3x"></i></div> --> */}
                        <br />
                      
                        <a href="#" className="h4 mb-3">Primary Health Promotion Programs</a>
                        <p className="mb-3">We partner with Organizations to bridge the Health Gap in Rural Communities.</p>
                        <br />
                        <a href="#" className="btn text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.8s">
                    <div className="feature-item">
                        <img src="img/phgex-logo.jpg" width="100%" />
                        {/* <!-- <div className="feature-icon mb-3"><i className="fas fa-microscope text-white fa-3x"></i></div> --> */}
                        <a href="#" className="h4 mb-3">Digital Entrepreneurship Programs</a>
                        <p className="mb-3">A blended learning approach(online and community-based) digital entrepreneurship training & mentorship program tailord for the Youths, Women and PwDs</p>
                        <a href="#" className="btn text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

  )
}

export default Projects